/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blue_Weak_Robin_DelightInputs */

const fr_blue_weak_robin_delight = /** @type {(inputs: Blue_Weak_Robin_DelightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Répétitions`)
};

/**

* @param {Blue_Weak_Robin_DelightInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const blue_weak_robin_delight = /** @type {((inputs?: Blue_Weak_Robin_DelightInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blue_Weak_Robin_DelightInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_blue_weak_robin_delight(inputs)
});